/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, inject, ref, toRefs, reactive, computed, onMounted, onBeforeUnmount } from '@vue/composition-api';
import { renderContent } from '../utils/render-tnode.js';
import Ripple from '../utils/ripple.js';
import { getKeepAnimationMixins } from '../config-provider/config-receiver.js';
import props from './option-props.js';
import { Checkbox } from '../checkbox/index.js';
import useLazyLoad from '../hooks/useLazyLoad.js';
import { getNewMultipleValue } from './util.js';
import { useConfig } from '../config-provider/useConfig.js';
import useCommonClassName from '../hooks/useCommonClassName.js';
import { useFormDisabled } from '../hooks/useFormDisabled.js';
import '@babel/runtime/helpers/typeof';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../_common/js/utils/set-style.js';
import '../config.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';
import '../checkbox/group.js';
import '../_chunks/dep-1461d230.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/intersection';
import 'lodash/isObject';
import 'lodash/isUndefined';
import '../checkbox/checkbox.js';
import '../checkbox/props.js';
import '../hooks/index.js';
import '../hooks/slots.js';
import 'lodash/isArray';
import '../hooks/useConfig.js';
import '../hooks/useDefaultValue.js';
import '../hooks/useDestroyOnClose.js';
import '../hooks/useElementLazyRender.js';
import '../_common/js/utils/observe.js';
import '../hooks/useGlobalIcon.js';
import '../hooks/useResizeObserver.js';
import '../hooks/useVirtualScrollNew.js';
import '../hooks/useVModel.js';
import '../hooks/useImagePreviewUrl.js';
import '../_common/js/upload/utils.js';
import '../_common/js/log/log.js';
import '../checkbox/constants.js';
import '../checkbox/store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../checkbox/hooks/useKeyboardEvent.js';
import '../checkbox/checkbox-group-props.js';
import '../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../checkbox/type.js';
import 'lodash/cloneDeep';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var keepAnimationMixins = getKeepAnimationMixins();
var _Option = defineComponent({
  name: "TOption",
  props: _objectSpread(_objectSpread({}, props), {}, {
    isCreatedOption: Boolean,
    multiple: Boolean,
    rowIndex: Number,
    trs: Map,
    scrollType: String,
    isVirtual: Boolean,
    bufferSize: Number,
    index: Number
  }),
  components: {
    TCheckbox: Checkbox
  },
  mixins: [keepAnimationMixins],
  directives: {
    Ripple: Ripple
  },
  setup: function setup(props2, context) {
    var selectProvider = inject("tSelect");
    var optionNode = ref(null);
    var _useCommonClassName = useCommonClassName(),
      sizeClassNames = _useCommonClassName.sizeClassNames,
      statusClassNames = _useCommonClassName.statusClassNames;
    var _useConfig = useConfig("classPrefix"),
      classPrefix = _useConfig.classPrefix;
    var _toRefs = toRefs(props2),
      value = _toRefs.value,
      label = _toRefs.label,
      multiple = _toRefs.multiple,
      disabled = _toRefs.disabled,
      panelElement = _toRefs.panelElement,
      scrollType = _toRefs.scrollType,
      bufferSize = _toRefs.bufferSize,
      index = _toRefs.index,
      isCreatedOption = _toRefs.isCreatedOption;
    var _useLazyLoad = useLazyLoad(panelElement, optionNode, reactive({
        type: scrollType,
        bufferSize: bufferSize
      })),
      _useLazyLoad$hasLazyL = _useLazyLoad.hasLazyLoadHolder,
      hasLazyLoadHolder = _useLazyLoad$hasLazyL === void 0 ? null : _useLazyLoad$hasLazyL,
      _useLazyLoad$tRowHeig = _useLazyLoad.tRowHeight,
      tRowHeight = _useLazyLoad$tRowHeig === void 0 ? null : _useLazyLoad$tRowHeig;
    var isHover = ref(false);
    var _useFormDisabled = useFormDisabled(),
      formDisabled = _useFormDisabled.formDisabled;
    var isSelected = computed(function () {
      if (multiple.value) {
        var _selectProvider$selec;
        if (props2.checkAll) {
          return selectProvider.isAllOptionsChecked.value;
        }
        return (_selectProvider$selec = selectProvider.selectValue.value) === null || _selectProvider$selec === void 0 ? void 0 : _selectProvider$selec.includes(props2.value);
      }
      return selectProvider.selectValue.value === props2.value;
    });
    var isIndeterminate = computed(function () {
      return multiple.value && !selectProvider.isAllOptionsChecked.value && selectProvider.selectValue.value.length > 0;
    });
    var isDisabled = computed(function () {
      return disabled.value || formDisabled.value || multiple.value && !isSelected.value && !props2.checkAll && selectProvider.isReachMaxLimit.value;
    });
    var mouseEvent = function mouseEvent(v) {
      isHover.value = v;
    };
    var labelText = computed(function () {
      return label.value || value.value;
    });
    var classes = computed(function () {
      var _ref;
      return ["".concat(classPrefix.value, "-select-option"), sizeClassNames[selectProvider && selectProvider.size.value], (_ref = {}, _defineProperty(_ref, statusClassNames.disabled, isDisabled.value), _defineProperty(_ref, statusClassNames.selected, isSelected.value), _defineProperty(_ref, "".concat(classPrefix.value, "-select-option__hover"), (isHover.value || selectProvider.hoverIndex.value === index.value) && !isDisabled.value && !isSelected.value), _ref)];
    });
    var handleClick = function handleClick(e) {
      if (isDisabled.value) return;
      e.preventDefault();
      if (isCreatedOption.value) {
        var _selectProvider$handl;
        (_selectProvider$handl = selectProvider.handleCreate) === null || _selectProvider$handl === void 0 || _selectProvider$handl.call(selectProvider, value.value);
      }
      if (multiple.value) {
        if (props2.checkAll) {
          selectProvider.handleCheckAllClick(e);
        } else {
          var newValue = getNewMultipleValue(selectProvider.selectValue.value, value.value);
          selectProvider.handleValueChange(newValue.value, {
            e: e,
            trigger: newValue.isCheck ? "check" : "uncheck"
          }, value.value);
          if (!selectProvider.reserveKeyword.value) {
            selectProvider.handlerInputChange("");
          }
        }
      } else {
        selectProvider.handleValueChange(value.value, {
          e: e,
          trigger: "check"
        }, value.value);
        selectProvider.handlePopupVisibleChange(false, {
          e: e
        });
      }
    };
    onMounted(function () {
      var trs = props2.trs,
        rowIndex = props2.rowIndex,
        scrollType2 = props2.scrollType,
        isVirtual = props2.isVirtual;
      if (scrollType2 === "virtual") {
        if (isVirtual) {
          trs.set(rowIndex, optionNode.value);
          context.emit("onRowMounted");
        }
      }
    });
    onBeforeUnmount(function () {
      if (props2.isVirtual) {
        var trs = props2.trs,
          rowIndex = props2.rowIndex;
        trs["delete"](rowIndex);
      }
    });
    return {
      isHover: isHover,
      isSelected: isSelected,
      isDisabled: isDisabled,
      isIndeterminate: isIndeterminate,
      mouseEvent: mouseEvent,
      classes: classes,
      selectProvider: selectProvider,
      labelText: labelText,
      optionNode: optionNode,
      tRowHeight: tRowHeight,
      hasLazyLoadHolder: hasLazyLoadHolder,
      handleClick: handleClick
    };
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
      mouseEvent = this.mouseEvent,
      labelText = this.labelText,
      title = this.title;
    var selfDefinedContent = renderContent(this, "default", "content");
    var optionChild = selfDefinedContent || h("span", [labelText]);
    var titleText = title || labelText;
    if (this.hasLazyLoadHolder) {
      return h("li", {
        "ref": "optionNode",
        "class": classes,
        "on": {
          "mouseenter": function mouseenter() {
            return mouseEvent(true);
          },
          "mouseleave": function mouseleave() {
            return mouseEvent(false);
          },
          "click": this.handleClick
        },
        "directives": [{
          name: "ripple",
          value: this.keepAnimation.ripple
        }],
        "attrs": {
          "title": titleText
        }
      }, [h("span", {
        "style": {
          height: "".concat(this.tRowHeight, "px"),
          border: "none"
        }
      })]);
    }
    return h("li", {
      "ref": "optionNode",
      "class": classes,
      "on": {
        "mouseenter": function mouseenter() {
          return mouseEvent(true);
        },
        "mouseleave": function mouseleave() {
          return mouseEvent(false);
        },
        "click": this.handleClick
      },
      "directives": [{
        name: "ripple",
        value: this.keepAnimation.ripple
      }],
      "attrs": {
        "title": titleText
      }
    }, [this.multiple ? h("t-checkbox", {
      "attrs": {
        "checked": this.isSelected,
        "disabled": this.isDisabled,
        "indeterminate": this.checkAll && this.isIndeterminate
      }
    }, [optionChild]) : optionChild]);
  }
});

export { _Option as default };
//# sourceMappingURL=option.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/select/option.js
// module id = null
// module chunks = 